import React, { useEffect, useState } from "react";
import { useResourceMutations } from "@/hooks/useResource";
import { FormDrawer } from "@/components/kit/FormDrawer";
import { TextField, TextareaField } from "@/components/kit/fields";
import { toast } from "sonner";

const empty = {
  name: "", contact: "", email: "", telegram: "", phone: "",
  website: "", notes: "",
};

export function AdvertiserDrawer({ open, item, onOpenChange }) {
  const { create, update } = useResourceMutations("advertisers");
  const [form, setForm] = useState(empty);
  const isEdit = !!item?.id;

  useEffect(() => {
    if (open) setForm(item ? { ...empty, ...item } : empty);
  }, [open, item]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name) return toast.error("Company name is required");
    const body = { ...form };
    delete body.revenue;
    if (isEdit) await update.mutateAsync({ id: item.id, body });
    else await create.mutateAsync(body);
    onOpenChange(false);
  };

  return (
    <FormDrawer open={open} onOpenChange={onOpenChange} title={isEdit ? "Edit Advertiser" : "New Advertiser"}
      subtitle={isEdit ? form.name : "Create an advertiser"} size="lg"
      onSave={save} saving={create.isPending || update.isPending} saveLabel={isEdit ? "Save changes" : "Create"} testId="advertiser-drawer">
      <div className="space-y-5">
        <TextField label="Company name" value={form.name} onChange={(v) => set("name", v)} testId="advertiser-name" />

        <div className="grid grid-cols-2 gap-4">
          <TextField label="Contact person" value={form.contact} onChange={(v) => set("contact", v)} testId="advertiser-contact" />
          <TextField label="Email" type="email" value={form.email} onChange={(v) => set("email", v)} testId="advertiser-email" />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <TextField label="Telegram" value={form.telegram} onChange={(v) => set("telegram", v)} placeholder="@handle" testId="advertiser-telegram" />
          <TextField label="Phone" value={form.phone} onChange={(v) => set("phone", v)} testId="advertiser-phone" />
        </div>

        <TextField label="Website" value={form.website} onChange={(v) => set("website", v)} placeholder="https://" testId="advertiser-website" />

        <TextareaField label="Notes" value={form.notes} onChange={(v) => set("notes", v)} />
      </div>
    </FormDrawer>
  );
}
